import React from 'react';
import Question from '../../interfaces/question';
import Survey from '../../interfaces/survey';

export interface ObjectId {
  id: number;
}

export interface ValueAnswer {
  question: ObjectId;
  value: string | null;
}

export interface ChoicesAnswer {
  question: ObjectId;
  choices: ObjectId[];
}

export interface ChosenOptionAnswer {
  question: ObjectId;
  chosenOption: ObjectId | null;
}

export type AnswerShape =
  | { value: string | null }
  | { choices: ObjectId[] }
  | { chosenOption: ObjectId | null };

export type MappedAnswer = ValueAnswer | ChoicesAnswer | ChosenOptionAnswer;

type QuestionId = number;
type ConditionalQuestionId = number;

interface DefaultValueProps {
  upsertMappedAnswers: (answers: Map<number, MappedAnswer>) => void;
  mappedAnswers: Map<number, MappedAnswer>;
  paginatedSurvey: Map<number, Question[]>;
  surveyPage: number;
  decreasePage: () => void;
  increasePage: () => void;
  conditionalQuestionIds: Map<QuestionId, ConditionalQuestionId[]>;
  setConditionalQuestionId: (
    questionId: QuestionId,
    conditionalQuestionId: ConditionalQuestionId[],
  ) => void;
  deleteConditionalQuestionId: (questionId: QuestionId) => void;
  survey: Survey | undefined;
  lastButtonAction: () => void;
  firstBackButtonAction?: () => void;
}

const defaultValue: DefaultValueProps = {
  upsertMappedAnswers: () => null,
  mappedAnswers: new Map(),
  paginatedSurvey: new Map(),
  surveyPage: 0,
  decreasePage: () => null,
  increasePage: () => null,
  conditionalQuestionIds: new Map(),
  setConditionalQuestionId: () => null,
  deleteConditionalQuestionId: () => null,
  survey: undefined,
  lastButtonAction: () => null,
};

export const SurveyPageContext = React.createContext(defaultValue);
